
import { animate, state, style, transition, trigger } from '@angular/animations'
import { ChangeDetectorRef, Compiler, Component, EventEmitter, Injector, Input, NgModuleRef, OnInit, Output, ViewChild } from '@angular/core'
import { MatPaginator, MatSort, MatTableDataSource, Sort } from '@angular/material'
import { DomSanitizer } from '@angular/platform-browser'


/**
 * @title Basic use of `<table mat-table>`
 */
@Component({
	selector: 'atyl-recherch-table',
	styleUrls: ['./recherche-table.component.scss'],
	templateUrl: './recherche-table.component.html',
	animations: [
		trigger('detailExpand', [
			state('collapsed', style({ height: '0px', minHeight: '0' })),
			state('expanded', style({ height: '*' })),
			transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		]),
	],
})


export class RechercheTableComponent implements OnInit {


	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator

	@Input() removeRow: boolean = false;

	@Input() data: any[] = [];
	@Input() columns: any[] = [];
	@Input() inited = new EventEmitter<any>();

	@Input() displayedColumns = [];
	@ViewChild(MatSort, { static: false }) sort: MatSort

	@Input() length: number = 0;
	@Input() pageSize: number = 10;
	@Input() currentPage: number = 0;
	@Input() page: number = 0;

	@Input() expanded: any[] = [];

	totalLength: number = 0;
	@Input() loading: boolean = false;

	@Output() loaded = new EventEmitter<boolean>();
	@Output() changePaged = new EventEmitter<any>();
	@Output() rowClicked = new EventEmitter<any>();
	@Output() removeLine = new EventEmitter<any>();
	@Output() sortByColumn = new EventEmitter<any>();
	@Output() changeExpanded = new EventEmitter<any>();

	expandedElement: any
	dataSource = new MatTableDataSource();
	constructor(private compiler: Compiler,
		private injector: Injector,
		private moduleRef: NgModuleRef<any>,
		private sanitizer: DomSanitizer,
		private cdf: ChangeDetectorRef
	) {

	}

	ngOnInit() {
		// this.paginator._intl.itemsPerPageLabel = 'Nombre par page:';
		// this.paginator._intl.getRangeLabel = (page, pageSize, length) => {
		// 	if (length == 0 || pageSize == 0) {
		// 		return `0 de ${length}`;
		// 	}
		// 	length = Math.max(length, 0);
		// 	const startIndex = page * pageSize;
		// 	const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
		// 	return `${startIndex + 1} – ${endIndex} de ${length}`;
		// };
		// this.inited.subscribe((item: any) => {
		// 	this.onInited(item);
		// });
		console.log('====================================')
		console.log(this.data, this.columns, this.displayedColumns)
		console.log('====================================')
	}

	ngOnChanges(changes: any) {
		if (changes.data && changes.data.currentValue)
			this.createTable()
	}
	ngAfterViewInit() {
		this.displayedColumns = this.columns.map(x => x.id)
		if (this.data)
			this.createTable()
		this.loaded.emit(true)
	}

	createTable() {
		this.dataSource.data = this.data
		this.page = this.currentPage
		this.loading = false
		//this.totalLength = 0;
		//this.totalLength = this.length;
	}

	addColmunn(id, title) {
		let column: any = {
			'id': id,
			'title': title
		}
		this.columns.push(column)
	}

	onRowClicked(row) {
		this.expandedElement = this.expandedElement === row ? null : row
		this.rowClicked.emit(row)
	}

	onInited(item) {

		this.loading = true
		// this.displayedColumns = this.columns.map(x => x.id);
		setTimeout(() => {
			this.createTable()
		})
	}

	setDirection() {
	}
	sortData(sort: Sort) {
		this.loading = true
		this.sortByColumn.emit(sort)
	}

	public handlePage(e: any) {
		//this.currentPage = e.pageIndex;
		//this.pageSize = e.pageSize;
		//	this.dataSource.data=[];
		this.totalLength = 0
		let pagination: any = {
			currentPage: e.pageIndex,
			pageSize: e.pageSize
		}
		this.loading = true
		this.changePaged.emit(pagination)
	}

	removeLineClicked(cell: any) {
		this.removeLine.emit(cell)
	}
}
